import PropTypes from 'prop-types'

import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'

import classes from './TablePlaceholder.module.scss'

const TablePlaceholder = ({ message = 'No data' }) => (
  <div className={classes.placeholderContainer}>
    <div className='d-flex align-items-center flex-column'>
      <GolferIcon className={classes.icon} />
      <h4 className='my-3'>{message}</h4>
    </div>
  </div>
)

TablePlaceholder.propTypes = {
  message: PropTypes.string.isRequired,
}

export default TablePlaceholder
